/* unplugin-vue-components disabled */import script from "./ActivityBrowser.vue?vue&type=script&setup=true&lang=js"
export * from "./ActivityBrowser.vue?vue&type=script&setup=true&lang=js"

import "./ActivityBrowser.vue?vue&type=style&index=0&id=b89c09ba&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b89c09ba"]])

export default __exports__